import Typography from '@material-ui/core/Typography';
import React from 'react';

const DateFormatter = (props) => {
  const { onClick, emptyText, column, row, defaultValue } = props;
  const value = defaultValue || props?.value || row[column?.id] || row[column?.key];

  if (!value) {
    return <Typography onClick={onClick}>{emptyText}</Typography>;
  }

  let date = '';
  let time = '';

  if (value.includes('T')) {
    [date, time] = value.split('T');
    time = time.split('.')[0].replace('Z', '');
  } else if (value.includes(' ')) {
    [date, time] = value.split(' ');
  } else {
    date = value;
    time = null;
  }

  return (
    <div className='flex w-full items-start justify-center flex-col'>
      {time && <span className='font-medium text-sm'>{time}</span>}
      <span className='font-normal text-sm'>{date}</span>
    </div>
  );
};

export default DateFormatter;
